export const chatFunctions = {
  typing: 'typing',
  'chat.msg': 'chatArrives',
  'chat.memberjoin': 'memberJoin',
  'chat.memberleave': 'memberLeave',
  'chat.rating': 'chatRating',
  'chat.comment': 'chatComment',
  'chat.request.rating': 'requestRating',
  'chat.file': 'fileAttachmentArrived',
  'chat.queue_position': 'revealQueuePos',
  last_read: 'lastRead',
};

/**
 * Craft necessary tags with the format of `livechat_info___<something>`
 */
export const livechatInfoTagsGenerator = (param: object): string[] => {
  const prefix = 'livechat_info';
  const bukabantuan = `${prefix}___bukabantuan`;
  let tags = [bukabantuan];
  Object.entries(param).forEach(entry => {
    if (entry[1]) {
      tags = [...tags, `${prefix}___${entry[0]}___${entry[1]}`];
    }
  });
  return tags;
};
